<template>
    <m-layout>
      <div fill-height class="fill-height" style="width:100%">
        <m-results></m-results>
      </div>
    </m-layout>
</template>
<script>
import MResults from '@/components/balance/results.vue'
export default {
  components: {
    'm-results': MResults
  },
  data () {
    return {
    };
  },
  methods: {
    eventClick: function (e) {
      console.log('event clicked', e);
    },
    getData () {}
  }
};
</script>

<style lang="scss">
.logo-home {
  opacity: 0.1;
  margin: 0 auto;
}
</style>
